export default class ThirdPartyParameter {
    id: number;
    warehouseInfoId: number;
    warehouseName: string;
    site: number;
    beginTime?: Date;
    endTime?: Date;
    isEffective: boolean;
    bulkyParameter: number;
}